var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4015_10423)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4015_10423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0V80H80V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4015_10423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1593 4.37115C42.4923 1.11326 37.51 1.11327 34.8427 4.37115L31.5366 8.40931L26.6544 6.56521C22.7155 5.07748 18.4009 7.56851 17.7198 11.7236L16.8757 16.8738L11.7255 17.7179C7.57048 18.3989 5.07942 22.7135 6.56718 26.6524L8.41125 31.5347L4.37308 34.8407C1.11521 37.508 1.11522 42.4904 4.37312 45.1577L8.41125 48.4637L6.56718 53.346C5.07942 57.2847 7.57045 61.5994 11.7255 62.2804L16.8757 63.1247L17.7198 68.2747C18.4009 72.4297 22.7155 74.9211 26.6544 73.4331L31.5366 71.5891L34.8427 75.6274C37.51 78.885 42.4923 78.885 45.1593 75.6274L48.4657 71.5891L53.348 73.4331C57.2867 74.9211 61.6013 72.4297 62.2823 68.2747L63.1267 63.1247L68.2767 62.2804C72.4317 61.5994 74.923 57.2847 73.435 53.346L71.591 48.4637L75.6293 45.1574C78.887 42.4904 78.887 37.508 75.6293 34.8407L71.591 31.5347L73.435 26.6524C74.923 22.7135 72.4317 18.3989 68.2767 17.7179L63.1267 16.8738L62.2823 11.7236C61.6013 7.56851 57.2867 5.07745 53.348 6.56521L48.4657 8.40931L45.1593 4.37115Z",
    fill: "#13B53E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6894 30.6906L37.356 54.0239C36.7307 54.6489 35.883 55.0003 34.999 55.0003C34.115 55.0003 33.267 54.6489 32.6419 54.0239L19.3086 40.6906L24.0226 35.9766L34.999 46.9529L55.9754 25.9766L60.6894 30.6906Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4015_10423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.b287a37a1bc91faf0f3a225fbaa7ea94.svg";
export { ForwardRef as ReactComponent };